<!-- <app-default-sidebar></app-default-sidebar> -->
<div class="app-body"> <!--black: dark | white:white | dark blue: blue-dark-->
   <app-default-header></app-default-header>
    <main class="main">
       <div class="container-fluid">
          <router-outlet></router-outlet>
       </div>
    </main>
    <!-- <app-default-right-sidebar></app-default-right-sidebar> -->
    <app-default-footer class="app-footer"></app-default-footer>
</div>

